<template>
  <el-dialog :title="title" :visible.sync="show" :append-to-body="true" :close-on-click-modal="false" width="552px" @close="onCloseDialog">
    <!-- @close="$emit('update:customerVisible', false)" -->
    <el-form ref="customer_form" :model="customer_form" label-width="95px">
      <el-form-item label="姓名：">
        <el-input v-model="customer_form.name" autocomplete="off" style="width:240px" placeholder="请输入姓名" :maxlength="15" :clearable="false"></el-input>
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="customer_form.sex" placeholder="请选择性别" style="width:240px">
          <el-option label="男" value="男"></el-option>
          <el-option label="女" value="女"></el-option>
          <el-option label="未知性别" value="未知性别"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号码：" :rules="[ { required: true, message: '手机号码不能为空',trigger: 'blur'}, { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '手机号格式错误', trigger: 'blur'} ]" prop="phone">
        <el-input v-model.number="customer_form.phone" autocomplete="off" style="width:240px" placeholder="请输入手机号码" :disabled="title === '新增顾客'?false:true" maxlength="11"></el-input>
        <!-- :disabled="customer_form.phone != '' -->
      </el-form-item>
      <div v-if="hidePhone == 0 ? false : title === '新增顾客' ? false : true" class="starPhoneDisabled">
        <span>{{ customer_form.phone.substring(0,3) }}</span>
        <samp>****</samp>
        <span>{{ customer_form.phone.substring(7,11) }}</span>
      </div>
      <el-form-item label="生日：">
        <el-date-picker v-model="customer_form.birthday" type="date" :editable="false" placeholder="选择日期" style="width:240px" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item label="顾客来源：">
        <el-select v-model="customer_form.source" placeholder="请选择顾客来源" style="width:240px">
          <el-option label="自进店" value="自进店"></el-option>
          <el-option label="电话咨询" value="电话咨询"></el-option>
          <el-option label="顾客介绍" value="顾客介绍"></el-option>
          <el-option label="员工介绍" value="员工介绍"></el-option>
          <el-option label="未知来源" value="未知来源"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="微信号：" prop="wxNumber">
        <el-input v-model="customer_form.wxNumber" :maxlength="20" autocomplete="off" style="width:240px" placeholder="请输入微信号"></el-input>
      </el-form-item>
      <el-form-item label="所在地区：">
        <el-cascader ref="cascaderAddr" v-model="customer_form.region" :options="city" :props="{ value: 'value', label: 'label'}" style="width:240px" @change="handleChange" />
      </el-form-item>
      <el-form-item label="详细地址：">
        <el-input v-model="customer_form.location" :maxlength="50" autocomplete="off" style="width:240px" placeholder="请输入详细地址"></el-input>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input v-model="customer_form.remark" type="textarea" :maxlength="100" autocomplete="off" style="width:414px" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item label="上传文件：">
        <div class="uploadFile">
          <UploadPictures :value="customer_form.images" @change="getPicturesList" @input="getPicturesList" @file="getPicturesFile"></UploadPictures>
          <UploadAttachment :value="customer_form.accessory" @change="getAttachmentList" @input="getAttachmentList"></UploadAttachment>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="show = false">取 消</el-button>
      <el-button type="primary" @click="beforeConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import axios from '@/http/index';
import {
  saveOrUpdate, getOneCustomerMsg, saveMsg, fetchPolice
} from '../api';
import city from './city';

export default {
  props: {
    customerVisible: Boolean, // 控制展示
    title: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      memberInfo: {},
      customer_form: {
        name: '',
        sex: '未知性别',
        phone: '',
        birthday: '',
        source: '未知来源',
        wxNumber: '',
        location: '',
        remark: '',
        region: [],
        province: '',
        city: '',
        area: '',
        combination: ''
      },
      city,
      show: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      hidePhone: window.sessionStorage.isHidePhone,
      // 6.7
      pictureList: [],
      pictureFile: {},
      attachmentList: [],
    };
  },
  watch: {
    customerVisible(val) {
      console.log(val, '组件');
      if (!val) {
        this.customer_form = {
          name: '',
          sex: '未知性别',
          phone: '',
          birthday: '',
          source: '未知来源',
          wxNumber: '',
          location: '',
          remark: ''
        };
        this.$refs.customer_form.clearValidate();
      }
    }
  },
  mounted() {
    this.show = this.customerVisible;
    if (this.title == '编辑顾客') {
      this.getEdit();
    }
  },
  methods: {
    getPicturesList(val) {
      this.pictureList = val;
    },
    getPicturesFile(val) {
      this.pictureFile = val;
    },
    getAttachmentList(val) {
      this.attachmentList = val;
    },
    handleChange(val) {
      const thsAreaCode = this.$refs.cascaderAddr.getCheckedNodes()[0].pathLabels; // 注意2： 获取label值
      this.customer_form.province = thsAreaCode[0];
      this.customer_form.city = thsAreaCode[1];
      this.customer_form.area = thsAreaCode[2];
      const thsAreaVal = val;
      this.customer_form.region = thsAreaVal;
      this.customer_form.combination = thsAreaVal[2] ? thsAreaVal[2] : thsAreaVal[1];
    },
    // 获取修改记录
    getEdit() {
      const data = {
        keyWord: window.sessionStorage.customerPhone
      };
      getOneCustomerMsg(data).then((res) => {
        if (res.code == 0) {
          this.customer_form.name = res.data.nickName ? res.data.nickName : '';
          this.customer_form.sex = res.data.sex ? res.data.sex : '';
          this.customer_form.phone = res.data.phone ? res.data.phone : '';
          this.customer_form.birthday = res.data.birthday ? res.data.birthday : '';
          this.customer_form.source = res.data.source ? res.data.source : '';
          this.customer_form.wxNumber = res.data.wechat ? res.data.wechat : '';
          this.customer_form.province = res.data.province ? res.data.province : '';
          this.customer_form.city = res.data.city ? res.data.city : '';
          this.customer_form.area = res.data.area ? res.data.area : '';
          this.customer_form.combination = res.data.region ? res.data.region : '';
          this.customer_form.region = res.data.region ? (res.data.region * 1 > 900000) ? ['900000', (res.data.region) * 1] : [(`${res.data.region.substring(0, 2)}0000`), (`${res.data.region.substring(0, 4)}00`), res.data.region] : [];
          this.customer_form.location = res.data.address ? res.data.address : '';
          this.customer_form.remark = res.data.remark ? res.data.remark : '';
          // 6.7
          res.data.accessory = res.data.accessory || [];
          this.customer_form.accessory = res.data.accessory.map((a) => ({
            url: a.url,
            name: this.getNameOfFile(a.url)
          }));
          res.data.images = res.data.images || [];
          this.customer_form.images = res.data.images.map((a) => ({
            url: a,
            name: this.getNameOfFile(a)
          }));
        } else {
          // console.log(res)
        }
      });
    },
    // 获取文件名称
    getNameOfFile(url) {
      const start = url.indexOf('_');
      const fileName = url.substring(start + 1, url.length);
      return fileName;
    },
    // 文件上传
    async uploadFile(fileList) {
      const fileAttachments = [];
      // 获取上传策略
      let result = null;
      let keysList = [];
      if (fileList && fileList.length) {
        result = await fetchPolice({}).then((res) => res);
        keysList = Object.keys(result.data);
      }
      const uploadList = [];
      for (let i = 0; i < fileList.length; i += 1) {
        const file = fileList[i];
        console.log(file);
        // 创建FormData对象
        const formData = new FormData();
        // 把返回的字段添加到FormData中
        keysList.forEach((key) => {
          formData.append(key, result.data[key]);
        });
        // 向formData中添加 key 字段, 值是文件路径 + 文件名
        formData.append('key', result.data.dir + file.name);
        // file 字段一定要放在formData的最后面
        formData.append('file', file.raw);
        if (file.status == 'success') {
          uploadList.push({
            code: 0,
            data: {
              filename: [file.url.replace(result.data.prefix, '')],
              size: ['500']
            }
          });
        } else {
          uploadList.push(axios.post(result.data.host, formData).then((res) => res.data));
        }
      }
      // 发送上传文件请求
      const resList = await Promise.all(uploadList);
      const isError = resList.some((e) => e.code !== 0);
      const code = isError ? 1 : 0;
      if (isError === false) {
        resList.forEach((e) => {
          const url = `${e.data.filename[0].replace('upload', '')}`;
          const fileSize = e.data.size[0];
          const start = e.data.filename[0].indexOf('_');
          const fileName = e.data.filename[0].substring(start + 1, e.data.filename[0].length);
          fileAttachments.push({
            attachment: url,
            filename: fileName,
            remark: null,
            size: fileSize
          });
        });
      }
      return { code, data: fileAttachments };
    },
    // 确定新增顾客--之前
    async beforeConfirm() {
      const pictures = await this.uploadFile(this.pictureList);
      const attachment = await this.uploadFile(this.attachmentList);
      this.onConfirm(pictures, attachment);
    },
    // 确定新增顾客
    onConfirm(pictures, attachment) {
      const Parr = [];
      const Aarr = [];
      pictures.data.forEach((a) => {
        Parr.push(a.attachment);
      });
      attachment.data.forEach((a) => {
        Aarr.push(a.attachment);
      });
      if (this.customer_form.birthday) {
        const day = this.customer_form.birthday;
        const d = new Date(day);
        this.customer_form.birthday = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
      }
      if (this.customer_form.wxNumber) {
        const reg = /^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/;
        if (!reg.test(this.customer_form.wxNumber)) {
          this.$message({ message: '请输入正确的微信号码', type: 'error' });
          return;
        }
      }
      const data = {
        accessory: Aarr,
        address: this.customer_form.location,
        area: this.customer_form.area,
        birthday: this.customer_form.birthday ? this.customer_form.birthday : '',
        city: this.customer_form.city,
        customerName: this.customer_form.name ? this.customer_form.name : '新增顾客',
        images: Parr,
        mainId: window.sessionStorage.mainId,
        phone: this.customer_form.phone,
        province: this.customer_form.province,
        region: this.customer_form.combination,
        remark: this.customer_form.remark,
        sex: this.customer_form.sex,
        source: this.customer_form.source,
        wechat: this.customer_form.wxNumber,
      };
      this.$refs.customer_form.validate((vaild) => {
        if (vaild) {
          if (this.title == '新增顾客') {
            saveMsg(data).then((res) => {
              if (res.code == 0) {
                this.show = false;
                // 顾客首页 新增顾客之后请求列表
                if (this.$parent.getCustomerList) {
                  this.$parent.getCustomerList(1);
                }
                // 激活顾客套餐
                if (this.$parent.confirmActivation) {
                  this.$parent.confirmActivation(this.customer_form.phone);
                } else {
                  this.$message({ message: '新增成功', type: 'success' });
                }
              } else {
                this.$message({ message: res.msg });
              }
            });
          } else {
            saveOrUpdate(data).then((res) => {
              if (res.code == 0) {
                this.$message({ message: '保存成功', type: 'success' });
                this.show = false;
                // 顾客首页 新增顾客之后请求列表
                if (this.$parent.getCustomerList) {
                  this.$parent.getCustomerList(1);
                }
              } else {
                this.$message({ message: res.msg });
              }
            });
          }
        } else {
          return false;
          // this.$message.error('请求异常');
        }
      });
    },
    // 取消新增
    cancel() {
      this.customer_form = {
        name: '',
        sex: '未知性别',
        phone: '',
        birthday: '',
        source: '未知来源',
        wxNumber: '',
        location: '',
        remark: ''
      };
      this.$refs.customer_form.resetFields();
    },
    onCloseDialog() {
      this.$emit('close', this.show);
    }
  },
};
</script>
<style lang="less" scoped>
.starPhoneDisabled {
  position: absolute;
  font-size: 14px;
  margin-top: -62px;
  margin-left: 95px;
  background-color: #f5f7fa;
  color: #c0c4cc;
  width: 208px;
  height: 38px;
  line-height: 38px;
  padding: 0 15px;
  cursor: not-allowed;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  user-select: none;
  span {
    float: left;
  }
  samp {
    line-height: 40px;
    float: left;
    font-size: 18px;
  }
}
.uploadFile {
  width: 372px;
  border: 1px dotted #C0CCDA;
  border-radius: 6px;
  padding: 20px;
}
</style>
